import { css } from "@emotion/react";

export const checkboxList = css`
  display: flex;
  flex-direction: column;
`;

export const spacer = css`
  &:not(div:first-of-type) {
    padding-top: 0.5rem;
  }
`;
